import React from "react";

export default (props) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 6.24 6.24"
    enableBackground="new 0 0 6.24 6.24"
  >
    <polygon
      points="3.96,0 3.481,0 2.28,6.24 2.759,6.24 3.96,0 "
      fill={props.color}
    />
  </svg>
);
